import { render } from "./SalonImgSlider.vue?vue&type=template&id=026b67ee&scoped=true"
import script from "./SalonImgSlider.vue?vue&type=script&lang=js"
export * from "./SalonImgSlider.vue?vue&type=script&lang=js"

import "./SalonImgSlider.vue?vue&type=style&index=0&id=026b67ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-026b67ee"]])

export default __exports__